import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="realwert"
export default class extends Controller {
	static values = {
		planungsinflation: Number,
	}

	static targets = ["inputRealwert", "checkboxRealwert", "inputSteigerung", "checkboxInflation"]

	connect() {
		this.update()
	}

	update() {
		const steigerung = currencyStringToFloat(this.inputSteigerungTarget.value) / 100.0

		this.inputRealwertTarget.innerHTML = percentage((steigerung + this.planungsinflationValue) * 100, 2)
	}

	aktivieren() {
		// console.log("realwert#aktivieren")
		if (this.checkboxRealwertTarget.checked) {
			// Checkbox "Inflationsabhängig" auf checked setzen
			if (!this.checkboxInflationTarget.checked) {
				const switchButton = this.checkboxInflationTarget.parentNode.querySelector("button[role='switch']")
				if (switchButton) switchButton.dispatchEvent(new Event("click"))
			}
		}
	}

	deaktivieren() {
		// console.log("realwert#deaktivieren")
		if (!this.checkboxInflationTarget.checked) {
			if (this.checkboxRealwertTarget.checked) {
				// Checkbox "Realwert" auf unchecked setzen
				const switchButton = this.checkboxRealwertTarget.parentNode.querySelector("button[role='switch']")
				if (switchButton) switchButton.dispatchEvent(new Event("click"))
			}
		}
	}
}
